import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataCurrentAccount } from '../types/masterdata-entities';
import { keyName } from './shared';

export const MASTERDATA_CURRENT_ACCOUNT =
  defineMasterdataEntity<MasterdataCurrentAccount>({
    name: 'current-account',
    responseKey: 'currentAccounts',
    displayWith: (a) => keyName(a.number, a.name ?? a.name1),
    secondaryWith: (a) => [a.postCode, a.city].filter(Boolean).join(' ') || null,
    icon: 'fa-regular fa-address-book',
    title: 'CPD-Kontosuche',
    label: 'CPD-Konto',
    placeholder: 'CPD-Konto suchen...',
    columns: [
      {
        label: 'CPD-Konto',
        type: 'entity',
        icon: 'fa-regular fa-address-book',
        value: (e) => keyName(e.number, e.name ?? e.name1),
        secondary: (e) =>
          [e.postCode, e.city].filter(Boolean).join(' ') || null,
      },
      { label: 'Nummer', value: (e) => e.number },
      { label: 'Subnummer', value: (e) => e.subNumber },
      { label: 'Bezeichnung', value: (e) => e.name },
      { label: 'Bezeichnung 1', value: (e) => e.name1 },
      { label: 'Bezeichnung 2', value: (e) => e.name2 },
      { label: 'Bezeichnung 3', value: (e) => e.name3 },
      { label: 'Straße', value: (e) => e.street },
      { label: 'PLZ', value: (e) => e.postCode },
      { label: 'Ort', value: (e) => e.city },
    ],
  });
